"use strict";

(function () {
  function r(e, n, t) {
    function o(i, f) {
      if (!n[i]) {
        if (!e[i]) {
          var c = "function" == typeof require && require;
          if (!f && c) return c(i, !0);
          if (u) return u(i, !0);
          var a = new Error("Cannot find module '" + i + "'");
          throw a.code = "MODULE_NOT_FOUND", a;
        }
        var p = n[i] = {
          exports: {}
        };
        e[i][0].call(p.exports, function (r) {
          var n = e[i][1][r];
          return o(n || r);
        }, p, p.exports, r, e, n, t);
      }
      return n[i].exports;
    }
    for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) o(t[i]);
    return o;
  }
  return r;
})()({
  1: [function (require, module, exports) {
    "use strict";

    var DURATION = 2000;

    // Splits "1.000+" into { prefix: '', target: 1000, suffix: '+', separator: '.' }
    function parseValue(text) {
      var match = text.match(/\d[\d.,]*/);
      if (!match) return null;
      var raw = match[0].replace(/[.,]$/, '');
      var end = match.index + raw.length;
      var separator = '';

      // Treat "." or "," followed by groups of 3 digits as a thousands separator
      if (/^\d{1,3}([.,]\d{3})+$/.test(raw)) {
        separator = raw.match(/[.,]/)[0];
        raw = raw.replace(/[.,]/g, '');
      } else if (/[.,]/.test(raw)) {
        return null; // decimals are left static
      }
      return {
        prefix: text.slice(0, match.index),
        target: parseInt(raw, 10),
        suffix: text.slice(end),
        separator: separator
      };
    }
    function format(number, separator) {
      var str = String(number);
      return separator ? str.replace(/\B(?=(\d{3})+(?!\d))/g, separator) : str;
    }
    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }
    function animate(el, data) {
      var start = null;
      function step(timestamp) {
        if (!start) start = timestamp;
        var progress = Math.min((timestamp - start) / DURATION, 1);
        var current = Math.round(easeOutCubic(progress) * data.target);
        el.textContent = data.prefix + format(current, data.separator) + data.suffix;
        if (progress < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    module.exports = {
      init: function () {
        var elements = document.querySelectorAll('.block-why-us__stat-value');
        if (!elements.length) return;

        // Leave final values in place for reduced motion or old browsers
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            animate(entry.target, entry.target._counter);
          });
        }, {
          threshold: 0.5
        });
        elements.forEach(function (el) {
          var data = parseValue(el.textContent.trim());
          if (!data) return;
          el._counter = data;
          el.setAttribute('aria-label', el.textContent.trim());
          el.textContent = data.prefix + '0' + data.suffix;
          observer.observe(el);
        });
      }
    };
  }, {}],
  2: [function (require, module, exports) {
    "use strict";

    var SVG_UP = '<svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 4l3-3 3 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var SVG_DOWN = '<svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1l3 3 3-3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    module.exports = {
      init: function () {
        document.querySelectorAll('.nek-filter__input[type="number"]').forEach(function (input) {
          var min = parseFloat(input.getAttribute('min')) || 0;
          var step = parseFloat(input.getAttribute('step')) || 1;

          // Wrap input so custom buttons sit inside the border
          var wrap = document.createElement('div');
          wrap.className = 'nek-spin-wrap';
          input.parentNode.insertBefore(wrap, input);
          wrap.appendChild(input);

          // Inject up/down buttons
          var btns = document.createElement('div');
          btns.className = 'nek-spin-btns';
          btns.innerHTML = '<button type="button" class="nek-spin-btn nek-spin-btn--up"   tabindex="-1" aria-hidden="true">' + SVG_UP + '</button>' + '<button type="button" class="nek-spin-btn nek-spin-btn--down" tabindex="-1" aria-hidden="true">' + SVG_DOWN + '</button>';
          wrap.appendChild(btns);
          btns.querySelector('.nek-spin-btn--up').addEventListener('click', function () {
            var val = parseFloat(input.value) || 0;
            input.value = val + step;
            input.dispatchEvent(new Event('change', {
              bubbles: true
            }));
          });
          btns.querySelector('.nek-spin-btn--down').addEventListener('click', function () {
            var val = parseFloat(input.value) || 0;
            var newVal = Math.max(min, val - step);
            input.value = newVal > 0 ? newVal : '';
            input.dispatchEvent(new Event('change', {
              bubbles: true
            }));
          });

          // Block scroll-wheel from changing value
          input.addEventListener('wheel', function (e) {
            e.preventDefault();
          }, {
            passive: false
          });
        });
      }
    };
  }, {}],
  3: [function (require, module, exports) {
    "use strict";

    module.exports = {
      $dom: {
        window: $('window'),
        body: $('body')
      },
      vars: {
        windowWidth: window.innerWidth
      },
      functions: {
        escKey: function (callback) {
          $(document).on('keyup', function (e) {
            if (e.keyCode === 27) {
              callback();
            }
          });
        },
        clickOutsideContainer: function (selector, container, closeBtn, callback) {
          selector.on('mouseup', function (e) {
            e.preventDefault();
            if (!container.is(e.target) && container.has(e.target).length === 0 && !closeBtn.is(e.target)) {
              callback();
            }
          });
        }
      }
    };
  }, {}],
  4: [function (require, module, exports) {
    "use strict";

    const Global = require('./global');
    module.exports = {
      /*-------------------------------------------------------------------------------
      	# Cache dom and strings
      -------------------------------------------------------------------------------*/
      $dom: {
        body: $('body'),
        menuBtn: $('.js-menu-btn'),
        menuNav: $('.js-main-nav'),
        menuHasSub: $('.menu-item-has-children'),
        domHeader: $('.site-header'),
        menuIconButton: $('.js-cat-btn'),
        categoriesBtns: $('[js-nav-submenu-btn]')
      },
      classes: {
        open: 'open',
        openMenu: 'menu-open',
        sticky: 'sticky'
      },
      /*-------------------------------------------------------------------------------
      	# Initialize
      -------------------------------------------------------------------------------*/
      init: function () {
        // get dom and strings
        const $dom = this.$dom;
        const classes = this.classes;

        // functions
        function closeNav() {
          $dom.menuBtn.removeClass(classes.open);
          $dom.menuNav.removeClass(classes.open);
          Global.$dom.body.removeClass(classes.openMenu);
        }
        if (Global.vars.windowWidth < 1199) {
          $dom.menuHasSub.each(function (i, el) {
            $(el).append('<span class="sub-icon font-plus-circle" data-open-sub></span>');
          });
        }

        // bind events
        $dom.menuBtn.on('click', function (e) {
          e.preventDefault();
          $dom.menuBtn.toggleClass(classes.open);
          $dom.menuNav.toggleClass(classes.open);
          Global.$dom.body.toggleClass(classes.openMenu);
        });
        $dom.menuNav.on('click', '[data-open-sub]', function () {
          if (Global.vars.windowWidth < 1199) {
            $(this).siblings('.sub-menu').slideToggle();
          }
        });
        $dom.categoriesBtns.on('click', e => {
          e.preventDefault();
          $(e.currentTarget).closest('.header-menu__cat-menu-item.has-children').toggleClass('active');
        });
        Global.functions.clickOutsideContainer($dom.menuNav, $dom.menuNav.children('ul'), $dom.menuBtn, closeNav);
        Global.functions.escKey(closeNav);
        function toggleMenu() {
          $dom.body.toggleClass('active');
          $dom.menuIconButton.toggleClass('active');
        }
        function closeMenu() {
          $dom.body.removeClass('active');
          $dom.menuIconButton.removeClass('active');
        }
        $dom.menuIconButton.on('click', function () {
          toggleMenu(this);
        });
        Global.functions.clickOutsideContainer($('body'), $('.header-menu__cat-menu-item'), $('.header-menu__cat-menu-btn-icon'), closeMenu);
        $(window).on('scroll', function () {
          if ($(window).scrollTop() >= 10) {
            $dom.body.addClass(classes.sticky);
            $dom.domHeader.addClass(classes.sticky);
          } else {
            $dom.body.removeClass(classes.sticky);
            $dom.domHeader.removeClass(classes.sticky);
          }
        });
      }
    };
  }, {
    "./global": 3
  }],
  5: [function (require, module, exports) {
    "use strict";

    module.exports = {
      init: function () {
        var $ = jQuery;
        var $sliderImages = $('.js-slider-images');
        if ($sliderImages.length) {
          $sliderImages.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            speed: 1000,
            autoplay: true,
            autoplaySpeed: 3000,
            arrows: false
          });
        }
        var $slider = $('.js-slider');
        if ($slider.length) {
          $slider.slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            speed: 1000,
            arrows: false,
            responsive: [{
              breakpoint: 991,
              settings: {
                slidesToShow: 3
              }
            }, {
              breakpoint: 767,
              settings: {
                slidesToShow: 2
              }
            }]
          });
        }

        // Cards have fixed widths (see _block-slider-locations.scss); the track
        // overflows the container to the right, so no infinite clones on the left.
        var $sliderLocations = $('.js-slider-locations');
        if ($sliderLocations.length) {
          $sliderLocations.slick({
            infinite: false,
            variableWidth: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            swipeToSlide: true,
            touchThreshold: 10,
            speed: 450,
            cssEase: 'cubic-bezier(0.22, 0.61, 0.36, 1)',
            arrows: false,
            dots: false
          });
        }
      }
    };
  }, {}],
  6: [function (require, module, exports) {
    jQuery(function ($) {
      // Site Menu
      const menu = require('./_site/menu');
      menu.init();

      // Slick Slider
      const sliders = require('./_site/sliders');
      sliders.init();

      // Filter number inputs
      const filter = require('./_site/filter');
      filter.init();

      // Stat counters
      const counter = require('./_site/counter');
      counter.init();
    });
  }, {
    "./_site/counter": 1,
    "./_site/filter": 2,
    "./_site/menu": 4,
    "./_site/sliders": 5
  }]
}, {}, [6]);